function MenuBrandSeparator(strLinkSet, firstDelimiter, secondDelimiter) {

    this.links = initLinks(strLinkSet, firstDelimiter, secondDelimiter);

    function initLinks(strLinkSet, firstDelimiter, secondDelimiter) {
        const links = [];
        strLinkSet.split(firstDelimiter).forEach((strLink) => {
            const linkAttributes = strLink.split(secondDelimiter);
            if (!linkAttributes[0] || !linkAttributes[1]) {
                return;
            }
            links.push({
                title: linkAttributes[0],
                ref: linkAttributes[1],
            });
        });

        return links.sort((a, b) => {
            const la = a.title.toLowerCase();
            const lb = b.title.toLowerCase();
            return (la > lb) ? 1 :
                (lb > la) ? -1 : 0;
        });
    }
}

MenuBrandSeparator.prototype.filterByInitial = function (c) {
    return this.links.filter((link) => {
        if (link.title.length < 1) {
            return false;
        }
        const linkInitial = link.title.slice(0, 1);
        return linkInitial.toLowerCase() === c
            || linkInitial.toUpperCase() === c;
    });
}

MenuBrandSeparator.prototype.filterEtc = function () {
    return this.links.filter((link) => {
        if (link.title.length < 1) {
            return false;
        }
        const linkInitial = link.title.slice(0, 1);
        return linkInitial.toLowerCase().match(/[a-z]/) === null;
    });
}


/** DISPLAY PC **/
function addMenuPcBrandList(menuBrandSeparator, targetId) {
    const target = document.getElementById(targetId);
    const alphabets = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ", "etc"];

    alphabets.forEach((c) => {
        const listItem = createAlphabetList(c);
        target.appendChild(listItem);

        const brands = (c === "etc")
            ? menuBrandSeparator.filterEtc()
            : menuBrandSeparator.filterByInitial(c);

        brands.forEach((brand) => {
            const listItem = createBrandListItem(brand);
            target.appendChild(listItem);
        });
    });

    function createAlphabetList(c) {
        const listItem = document.createElement("li");
        listItem.classList.add("brand_alphabet");
        listItem.textContent = c;
        return listItem;
    }

    function createBrandListItem(brand) {
        const listItem = document.createElement("li");
        const anchor = document.createElement("a");

        anchor.href = brand.ref;
        anchor.textContent = brand.title;

        listItem.appendChild(anchor);
        return listItem;
    }
}

/** DISPLAY SP **/
function MenuBrandSeparator(strLinkSet, firstDelimiter, secondDelimiter) {

    this.links = initLinks(strLinkSet, firstDelimiter, secondDelimiter);

    function initLinks(strLinkSet, firstDelimiter, secondDelimiter) {
        const links = [];
        strLinkSet.split(firstDelimiter).forEach((strLink) => {
            const linkAttributes = strLink.split(secondDelimiter);
            if (!linkAttributes[0] || !linkAttributes[1]) {
                return;
            }
            links.push({
                title: linkAttributes[0],
                ref: linkAttributes[1],
            });
        });

        return links.sort((a, b) => {
            const la = a.title.toLowerCase();
            const lb = b.title.toLowerCase();
            return (la > lb) ? 1 :
                (lb > la) ? -1 : 0;
        });
    }
}

MenuBrandSeparator.prototype.filterByInitial = function (c) {
    return this.links.filter((link) => {
        if (link.title.length < 1) {
            return false;
        }
        const linkInitial = link.title.slice(0, 1);
        return linkInitial.toLowerCase() === c
            || linkInitial.toUpperCase() === c;
    });
}

MenuBrandSeparator.prototype.filterEtc = function () {
    return this.links.filter((link) => {
        if (link.title.length < 1) {
            return false;
        }
        const linkInitial = link.title.slice(0, 1);
        return linkInitial.toLowerCase().match(/[a-z]/) === null;
    });
}


/** DISPLAY PC **/
function addMenuPcBrandList(menuBrandSeparator, targetId) {
    const target = document.getElementById(targetId);
    const alphabets = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ", "etc"];

    alphabets.forEach((c) => {
        const listItem = createAlphabetList(c);
        target.appendChild(listItem);

        const brands = (c === "etc")
            ? menuBrandSeparator.filterEtc()
            : menuBrandSeparator.filterByInitial(c);

        brands.forEach((brand) => {
            const listItem = createBrandListItem(brand);
            target.appendChild(listItem);
        });
    });

    function createAlphabetList(c) {
        const listItem = document.createElement("li");
        listItem.classList.add("brand_alphabet");
        listItem.textContent = c;
        return listItem;
    }

    function createBrandListItem(brand) {
        const listItem = document.createElement("li");
        const anchor = document.createElement("a");

        anchor.href = brand.ref;
        anchor.textContent = brand.title;

        listItem.appendChild(anchor);
        return listItem;
    }
}

/** DISPLAY SP **/
function addMenuSpBrandList(menuBrandSeparator, targetId, menuCategory) {
    const target = document.getElementById(targetId);

    // サイトの言語設定を取得
    const siteLanguage = window.siteLanguage; // Liquidで埋め込んだ変数
    const isJapanese = siteLanguage === "ja"; // サイトの言語が日本語かどうか判定

    // title
    const titleListItem = createTitleListItem(isJapanese);
    target.appendChild(titleListItem);
    
    // brand list
    const alphabets = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ", "#"];
    alphabets.forEach((c) => {
        const brands = (c === "#")
            ? menuBrandSeparator.filterEtc()
            : menuBrandSeparator.filterByInitial(c);

        brands.forEach((brand) => {
            const listItem = createBrandListItem(brand);
            target.appendChild(listItem);
        });
    });

    // all brand
    const allBrandListItem = createAllBrandLineItem(isJapanese);
    target.appendChild(allBrandListItem);

    function createBrandListItem(brand) {
        const listItem = document.createElement("li");

        const anchor = document.createElement("a");
        anchor.href = brand.ref;
        anchor.textContent = brand.title;
        anchor.dataset.func = "onbrands";
        anchor.dataset.args = `'${menuCategory}', '${brand.title}'`;
        listItem.appendChild(anchor);

        return listItem;
    }

    function createTitleListItem(isJapanese) {
        const listItem = document.createElement("li");

        const strong = document.createElement("strong");
        // サイトの言語設定に基づいてテキストを設定
        strong.innerText = isJapanese ? "ブランド A-Z" : "Brand A-Z";

        listItem.appendChild(strong);
        return listItem;
    }

    function createAllBrandLineItem(isJapanese) {
        const listItem = document.createElement("li");
        listItem.classList.add("all-brands");

        const anchor = document.createElement("a");
        anchor.href = `/collections/${menuCategory}`;
        // サイトの言語設定に基づいてテキストを設定
        anchor.textContent = isJapanese ? "すべてのブランド一覧" : "All Brands";
        anchor.dataset.func = "onroot";
        anchor.dataset.args = menuCategory;

        listItem.appendChild(anchor);

        return listItem;
    }
}